import {MainVideoState} from "../definitions/MainVideoState";
import {stop} from "./Stop";
import {updateButtonsFromState} from "../state-change-side-effects/UpdateButtonsFromState";

export const toggleRuler = (state: MainVideoState) => {
    const nextShouldShowRuler = !state.shouldShowRuler;

    if (nextShouldShowRuler && (state.videoIsPlaying || state.desiredPlaybackState === true)) {
        stop(state);
        updateButtonsFromState(state);
    }

    state.shouldShowRuler = nextShouldShowRuler;
};
